import axiosInstance from '@/utils/https';

export const fetchInstagramPosts = async () => {
  try {
    const url = `https://graph.instagram.com/v17.0/8411877442255036/media?fields=id,media_type,media_url,permalink,like_count,caption,timestamp&access_token=${process.env.NEXT_PUBLIC_INSTAGRAM_ACCESS_TOKEN}&limit=5`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};
